import React, {MouseEventHandler} from 'react';
import radium from 'radium';
import { ThemeContext } from '../theme/Theme.jsx'

// Styles
import './Button.scss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface ButtonProps {
	name: string,
	buttonText?: string,
	type?: any,
	onClick?: MouseEventHandler,
	btnStyle?: any,
	buttonContainerStyle?: any,
	iconName?: any,
	iconStyle?: any,
	label?: string,
	disabled ?: boolean
}

const defaultProps = {
	type: 'button'
};


function Button(propsIn: ButtonProps) {
	const props = {...defaultProps, ...propsIn};
	const context = React.useContext(ThemeContext);
	const {
		name,
		buttonText,
		onClick,
		btnStyle,
		buttonContainerStyle,
		iconName,
		iconStyle,
		type,
		label,
	} = props;

	const style: any = {
		default: {
			color: context.themeManager.value('default-button', 'color', 'fg-color-button-default'),
			backgroundColor: context.themeManager.value('default-button', 'backgroundColor',
				'bg-color-button-default'),
			fontSize: context.themeManager.value('default-button', 'fontSize', 'font-size-150'),
			fontWeight: context.themeManager.valueOrDefault('default-button', 'fontWeight', null, '400'),
			border: context.themeManager.valueOrDefault('default-button', 'border', null, 'none'),
			':hover': {
				color: context.themeManager.value('default-button', 'colorHover', 'fg-color-button-hightlight'),
				backgroundColor: context.themeManager.value('default-button', 'backgroundColorHover','bg-color-button-hightlight'),
				border: context.themeManager.valueOrDefault('default-button', 'borderHover', null, 'none'),
				fontSize: context.themeManager.value('default-button', 'fontSizeHover', 'font-size-150'),
				fontWeight: context.themeManager.valueOrDefault('default-button', 'fontWeightHover', null, '400'),
			}
		},
		highlight: {
			color: context.themeManager.value('hightlight-button', 'color', 'fg-color-button-hightlight'),
			backgroundColor: context.themeManager.value('hightlight-button', 'backgroundColor',
				'bg-color-button-hightlight'),
			fontSize: context.themeManager.value('hightlight-button', 'fontSize', 'font-size-150'),
			fontWeight: context.themeManager.valueOrDefault('hightlight-button', 'fontWeight', null, '400'),
			border: context.themeManager.valueOrDefault('hightlight-button', 'border', null, 'none'),
			':hover': {
				color: context.themeManager.value('hightlight-button', 'colorHover', 'fg-color-button-hightlight'),
				backgroundColor: context.themeManager.value('hightlight-button', 'backgroundColorHover','bg-color-button-hightlight'),
				border: context.themeManager.valueOrDefault('hightlight-button', 'borderHover', null, 'none'),
				fontSize: context.themeManager.value('hightlight-button', 'fontSizeHover', 'font-size-150'),
				fontWeight: context.themeManager.valueOrDefault('hightlight-button', 'fontWeightHover', null, '400'),
			}
		},
	};

	const randomId = parseInt(String(Math.random() * 100000), 10);
	return (
		<div className="button__container" style={buttonContainerStyle}>
			<button
				className={props.disabled ? 'leo-button disabled' : 'leo-button'}
				id={name + randomId}
				name={name}
				type={type}
				style={btnStyle ? style[btnStyle] : style.default}
				onClick={onClick}
				disabled={props.disabled}
				aria-label={label || buttonText}
			>
				{iconName &&
					<FontAwesomeIcon
						className="btn_icon"
						icon={iconName}
						style={iconStyle}
					/>
				}
				{buttonText}
			</button>
		</div>
	);
}

export default radium(Button);
